(function () {
    'use strict';

    /* ================================
       HELPERS
    ================================= */
    const safeInit = (fn, name) => {
        try {
            fn();
        } catch (e) {
            console.error(`❌ Error in ${name}:`, e);
        }
    };

    /* ================================
       PRODUCT GALLERY
    ================================= */
    const initGallery = () => {
        const mainImage = document.getElementById('MainProductImage');
        const thumbnails = document.querySelectorAll('.Product__Thumbnail');
        const dots = document.querySelectorAll('.flickity-page-dots .dot');

        if (!mainImage || !thumbnails.length) return;

        let currentIndex = 0;
        const images = [];

        thumbnails.forEach((thumb, index) => {
            images.push(thumb.dataset.image);

            thumb.addEventListener('click', (e) => {
                e.preventDefault();
                currentIndex = index;
                updateImage();
            });
        });

        const updateImage = () => {
            if (!images[currentIndex]) return;

            mainImage.src = images[currentIndex];

            thumbnails.forEach(t => t.classList.remove('is-active'));
            thumbnails[currentIndex]?.classList.add('is-active');

            dots.forEach(dot => dot.classList.remove('is-selected'));
            dots[currentIndex]?.classList.add('is-selected');
        };

        document.querySelector('[data-direction="next"]')?.addEventListener('click', () => {
            currentIndex = (currentIndex + 1) % images.length;
            updateImage();
        });

        document.querySelector('[data-direction="previous"]')?.addEventListener('click', () => {
            currentIndex = (currentIndex - 1 + images.length) % images.length;
            updateImage();
        });

        dots.forEach(dot => {
            dot.addEventListener('click', function () {
                currentIndex = parseInt(this.dataset.index);
                updateImage();
            });
        });

        updateImage();
    };

    /* ================================
       BUNDLE (QTY + ADD TO CART)
    ================================= */
    const initBundle = () => {
        const forms = document.querySelectorAll('.BundleForm');
        if (!forms.length) return;

        forms.forEach(form => {
            const input = form.querySelector('.bundle-qty-input');
            const plus = form.querySelector('.qty-plus');
            const minus = form.querySelector('.qty-minus');

            if (!input) return;

            // ➕ плюс
            plus?.addEventListener('click', () => {
                input.value = parseInt(input.value || 1) + 1;
            });

            // ➖ мінус
            minus?.addEventListener('click', () => {
                input.value = Math.max(1, parseInt(input.value || 1) - 1);
            });

            // 🔥 submit — головне
            form.addEventListener('submit', (e) => {
                // якщо тема ловить submit сама → нічого не робимо

                // fallback якщо тема не AJAX
                setTimeout(() => {
                    const btn = document.querySelector(
                        '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]'
                    );
                    btn?.click();
                }, 300);
            });
        });
    };

    /* ================================
       CUSTOM SCROLLBAR
    ================================= */
    const initCustomScrollbar = () => {
        const wrapper = document.querySelector('.bundle-list-wrapper');
        if (!wrapper) return;

        const list = wrapper.querySelector('.bundle-list');
        const thumb = wrapper.querySelector('.bundle-scrollbar-thumb');

        if (!list || !thumb) return;

        const updateThumb = () => {
            const ratio = list.clientHeight / list.scrollHeight;
            const thumbHeight = Math.max(ratio * list.clientHeight, 30);

            thumb.style.height = thumbHeight + 'px';

            const scrollRatio = list.scrollTop / (list.scrollHeight - list.clientHeight);
            const top = scrollRatio * (list.clientHeight - thumbHeight);

            thumb.style.top = top + 'px';
        };

        list.addEventListener('scroll', updateThumb);

        // DRAG
        let isDragging = false;
        let startY = 0;
        let startTop = 0;

        thumb.addEventListener('mousedown', (e) => {
            isDragging = true;
            startY = e.clientY;
            startTop = thumb.offsetTop;
            document.body.style.userSelect = 'none';
        });

        document.addEventListener('mousemove', (e) => {
            if (!isDragging) return;

            const delta = e.clientY - startY;
            const maxTop = list.clientHeight - thumb.offsetHeight;

            const newTop = Math.max(0, Math.min(startTop + delta, maxTop));

            const scrollRatio = newTop / maxTop;
            list.scrollTop = scrollRatio * (list.scrollHeight - list.clientHeight);
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
            document.body.style.userSelect = '';
        });

        updateThumb();
    };

    /* ================================
       PRODUCT HEIGHT FIX (ABSOLUTE ELEMENT)
    ================================= */
    const initProductHeightFix = () => {
        const mediaQuery = window.matchMedia('(min-width: 1008px)');

        const updateHeight = () => {
            if (!mediaQuery.matches) {
                // 🔥 скидаємо якщо мобілка
                document.querySelectorAll('.Product__Wrapper').style.minHeight = '';
                return;
            }

            let product = document.querySelectorAll('.Product__Wrapper')
                const info = product.querySelector('.Product__InfoWrapper');
                if (!info) return;

                const productHeight = product.offsetHeight;
                const infoHeight = info.offsetHeight;

                // якщо абсолютний блок більший → розтягуємо контейнер
                if (infoHeight > productHeight) {
                    product.style.minHeight = infoHeight + 'px';
                }

        };

        // INIT
        updateHeight();

        // 🔁 on resize
        window.addEventListener('resize', updateHeight);

        // 🔁 якщо контент довантажується (images, ajax)
        window.addEventListener('load', updateHeight);
    };

    /* ================================
   NEWSLETTER FORM (AJAX)
================================= */
    const initNewsletterForm = () => {
        const form = document.querySelector('.newsletter-split__form form');
        if (!form) return;

        const input = form.querySelector('input[type="email"]');

        // створюємо контейнер для повідомлення
        let messageEl = form.querySelector('.newsletter-message');
        if (!messageEl) {
            messageEl = document.createElement('div');
            messageEl.className = 'newsletter-message';
            input.insertAdjacentElement('afterend', messageEl);
        }

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const email = input.value.trim();

            // проста валідація
            if (!email || !email.includes('@')) {
                showMessage('Bitte geben Sie eine gültige E-Mail-Adresse ein.', 'error');
                scrollToForm();
                return;
            }

            const formData = new FormData(form);

            try {
                const response = await fetch('/contact', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Accept': 'application/json'
                    }
                });

                // Shopify часто редіректить → ок вважаємо success
                if (response.ok) {
                    showMessage('Danke! Du hast dich erfolgreich angemeldet 🎉', 'success');
                    form.reset();
                } else {
                    throw new Error('Request failed');
                }

            } catch (error) {
                console.error(error);
                showMessage('Etwas ist schiefgelaufen. Bitte versuche es erneut.', 'error');
            }

            scrollToForm();
        });

        /* ===== helpers ===== */

        function showMessage(text, type) {
            messageEl.textContent = text;
            messageEl.classList.remove('is-success', 'is-error');
            messageEl.classList.add(type === 'success' ? 'is-success' : 'is-error');
        }

        function scrollToForm() {
            const rect = form.getBoundingClientRect();
            const offset = window.scrollY + rect.top - (window.innerHeight / 2) + (rect.height / 2);

            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
        }
    };

    /* ================================
   ANCHOR SCROLL OFFSET
================================= */
    const initAnchorOffset = () => {
        const OFFSET_VH = 30;

        const scrollToHash = (hash) => {
            if (!hash) return;

            const target = document.querySelector(hash);
            if (!target) return;

            const offset = window.innerHeight * (OFFSET_VH / 100);
            const elementTop = target.getBoundingClientRect().top + window.scrollY;
            const finalPosition = elementTop - offset;

            window.scrollTo({
                top: finalPosition,
                behavior: 'smooth'
            });
        };

        document.addEventListener('click', (e) => {
            const link = e.target.closest('a[href^="#"]');
            if (!link) return;

            const hash = link.getAttribute('href');

            if (!hash || hash === '#') return;

            const target = document.querySelector(hash);
            if (!target) return;

            e.preventDefault();
            scrollToHash(hash);

            history.pushState(null, '', hash);
        });

        if (window.location.hash) {
            setTimeout(() => {
                scrollToHash(window.location.hash);
            }, 100);
        }
    };

    /* ================================
       INIT
    ================================= */
    document.addEventListener('DOMContentLoaded', () => {
        safeInit(initGallery, 'Gallery');
        safeInit(initBundle, 'Bundle');
        safeInit(initCustomScrollbar, 'Custom Scrollbar');
        // safeInit(initProductHeightFix, 'Product Height Fix');
        // safeInit(initNewsletterForm, 'Newsletter Form');
        safeInit(initAnchorOffset, 'Anchor Offset');
    });

})();